import type { RequiredRole } from '@/entities/workspace-config';

/**
 * 라우트 단일 소스 (single source of truth)
 *
 * path, title, componentKey, requiredRole을 함께 정의해
 * fallback-route-config와 routes.ts가 인덱스 동기화 없이 파생할 수 있습니다.
 */
export interface RoutePattern {
  path: string[];
  title: string;
  componentKey: string;
  requiredRole: RequiredRole;
}

export const ROUTE_PATTERNS: RoutePattern[] = [
  { path: ['home'], title: '홈', componentKey: 'HomePage', requiredRole: 'Operator' },
  {
    path: ['activity'],
    title: '액티비티',
    componentKey: 'ActivityPage',
    requiredRole: 'Operator',
  },
  {
    path: ['orders', 'list'],
    title: '주문 목록',
    componentKey: 'OrderListPage',
    requiredRole: 'Operator',
  },
  {
    path: ['orders', ':misoOrderId'],
    title: '#?displayId',
    componentKey: 'OrderDetailPage',
    requiredRole: 'Operator',
  },
  {
    path: ['planners', 'list'],
    title: '플래너 목록',
    componentKey: 'PlannerListPage',
    requiredRole: 'Operator',
  },
  {
    path: ['planners', ':plannerId'],
    title: '?displayName 플래너',
    componentKey: 'PlannerDetailPage',
    requiredRole: 'Operator',
  },
  {
    path: ['my', 'planner'],
    title: '상담지도',
    componentKey: 'PlannerPage',
    requiredRole: 'Planner',
  },
  {
    path: ['my', 'counsels'],
    title: '상담 목록',
    componentKey: 'CounselListPage',
    requiredRole: 'Planner',
  },
  {
    path: ['my', 'profile'],
    title: '내 정보',
    componentKey: 'PlannerMyProfilePage',
    requiredRole: 'Planner',
  },
  {
    path: ['my', 'counsels', ':visitCounselId', 'start'],
    title: '상담 시작',
    componentKey: 'CounselStartPage',
    requiredRole: 'Planner',
  },
  {
    path: ['my', 'counsels', ':visitCounselId'],
    title: '상담 상세',
    componentKey: 'CounselDetailPage',
    requiredRole: 'Planner',
  },
  {
    path: ['counsel-map'],
    title: '상담지도',
    componentKey: 'CounselMapPage',
    requiredRole: 'Operator',
  },
  {
    path: ['moving-items'],
    title: '이사 품목',
    componentKey: 'MovingItemManagePage',
    requiredRole: 'Staff',
  },
  {
    path: ['settings', 'permissions'],
    title: '권한 설정',
    componentKey: 'PermissionsPage',
    requiredRole: 'Engineer',
  },
  {
    path: ['settings', 'camera'],
    title: '카메라 설정',
    componentKey: 'CameraSettingsPage',
    requiredRole: 'Planner',
  },
  {
    path: ['my', 'change-announcements'],
    title: '변경 안내',
    componentKey: 'ChangeAnnouncementPage',
    requiredRole: 'Planner',
  },
  {
    path: ['change-announcements', 'status'],
    title: '변경 안내 이수 현황',
    componentKey: 'ChangeAnnouncementStatusPage',
    requiredRole: 'Operator',
  },
  { path: ['404'], title: '404', componentKey: 'NotFoundPage', requiredRole: 'Planner' },
];
